import type { FirebaseApp } from 'firebase/app';

import { initFirebasePerformance } from '../monitoring/firebase-performance';
import { initSentry } from '../monitoring/sentry';

/**
 * Single entry point for all non-essential telemetry. Called only once the
 * consent gate has decided it may run (either the region does not require
 * consent, or the user granted it). Both underlying inits are already
 * idempotent and env/prod-gated, so a duplicate call is harmless.
 *
 * If you later gain legal comfort treating crash reporting as legitimate
 * interest, move `initSentry()` out of here and back to an unconditional call
 * — the gate would then govern Firebase Performance only.
 */
let started = false;

export function startTelemetry(app: FirebaseApp | null): void {
  if (started) {
    return;
  }
  started = true;
  initSentry({ firebaseConfigured: Boolean(app) });
  initFirebasePerformance(app);
}
